<template>
  <div class="face-guide" :class="{ 'face-guide--visible': visible, 'face-guide--active': active }" aria-hidden="true">
    <svg class="face-guide__svg" viewBox="0 0 200 260" preserveAspectRatio="xMidYMid meet">
      <defs>
        <clipPath :id="clipId">
          <path :d="FACE_PATH" />
        </clipPath>
        <linearGradient :id="fillId" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="currentColor" stop-opacity="0.1" />
          <stop offset="100%" stop-color="currentColor" stop-opacity="0.03" />
        </linearGradient>
      </defs>
      <path class="face-guide__fill" :d="FACE_PATH" :fill="`url(#${fillId})`" />
      <g :clip-path="`url(#${clipId})`">
        <line class="face-guide__line" x1="0" y1="104" x2="200" y2="104" />
        <line class="face-guide__line" x1="0" y1="146" x2="200" y2="146" />
      </g>
      <path class="face-guide__outline" :d="FACE_PATH" />
    </svg>
  </div>
</template>

<script setup>
/**
 * FaceGuideOverlay — овал-подсказка для лица с линиями уровня глаз (экран 5, калибровка).
 * Кладётся в слот #overlay рамки видео; занимает её целиком и не ловит клики.
 *
 * <FaceGuideOverlay :visible="phase === 'calibration'" :active="faceDetected" />
 *
 * props: visible (плавное появление/исчезновение), active (лицо найдено → лаймовый контур со свечением).
 */
defineProps({
  visible: { type: Boolean, default: true },
  active: { type: Boolean, default: false },
});

// Яйцевидный контур лица: шире на уровне висков, сужается к подбородку.
const FACE_PATH =
  "M100 14 C148 14 176 50 176 106 C176 168 142 232 100 246 C58 232 24 168 24 106 C24 50 52 14 100 14 Z";

const uid = `fg${Math.random().toString(36).slice(2, 9)}`;
const clipId = `${uid}-clip`;
const fillId = `${uid}-fill`;
</script>

<style scoped>
.face-guide {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  color: rgba(255, 255, 255, 0.85);
  opacity: 0;
  transition: opacity var(--cb-dur-slow) var(--cb-ease), color var(--cb-dur) var(--cb-ease);
}

.face-guide--visible {
  opacity: 1;
}

.face-guide--active {
  color: var(--cb-lime);
}

.face-guide__svg {
  height: 84%;
  width: auto;
  max-width: 70%;
  aspect-ratio: 200 / 260;
  overflow: visible;
}

.face-guide__outline {
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  vector-effect: non-scaling-stroke;
}

.face-guide__line {
  stroke: currentColor;
  stroke-opacity: 0.55;
  stroke-width: 1.4;
  vector-effect: non-scaling-stroke;
}

.face-guide--active .face-guide__svg {
  filter: drop-shadow(0 0 6px rgba(221, 245, 90, 0.65));
}
</style>
